"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M20 5v13a1 1 0 01-1 1H1a1 1 0 01-1-1V5h20zm-3-4h2a1 1 0 011 1v1h-3V1zm-2 2H0V2a1 1 0 011-1h14v2z"];
//# sourceMappingURL=modal-filled.js.map